import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconCaution = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 61,
	viewBox: "0 0 60 61",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27.2579 14.1461C28.782 11.4028 32.7272 11.4028 34.2512 14.1461L52.4531 46.9096C53.9343 49.5757 52.0064 52.8521 48.9565 52.8521H12.5526C9.50269 52.8521 7.57482 49.5757 9.056 46.9095L27.2579 14.1461ZM33.2546 45.3521H28.2546V40.3521H33.2546V45.3521ZM28.2546 35.3521H33.2546V25.3521H28.2546L28.2546 35.3521Z",
		fill: "#FD5354"
	})
});
export default SvgIconCaution;
